/** @format */

import { postMethod } from "core-lib/utils/apiV2";
import { apiConfig } from "core-lib/config/config";
import { SummaryData } from "../types/Summary";
import { DictType } from "core-lib/types/Helper";
import { getDefaultHeaders } from "core-lib/utils/network";

function serializeLineItem(el) {
  let items = [];
  if (el?.ui_type === "collpasible" && el?.items?.length) {
    el?.items.forEach((item) => items.push(serializeLineItem(item)));
  }
  return {
    labelText: el.text,
    labelColor: el.text_color,
    amountText: el.amount,
    amountColor: el.amount_color,
    showInfo: el.show_info,
    infoText: el.info_msg,
    strikeThrough: el.show_strike_amount,
    strikeAmount: el.strike_amount,
    strikeAmountColor: el.strike_amount_color,
    isBold: el.is_bold,
    viewBreakup: el?.view_breakup,
    items,
  };
}

function serializeExtraDetails(el){
  return {
    sku: el?.sku,
    unitPrice: el?.unit_price,
    feeAmount: el?.fee_amount,
    offenceName: el?.offence_name,
    settlementMedium: el?.settlement_medium,
    challanNumber: el?.challan_number,
    strikeFeeAmount: el?.striked_service_fee
  }
}
function serializeSummary(data): SummaryData {
  const summary: SummaryData = {
    totalOrderSavings: data?.total_savings,
    savingAmount: data?.saving_amount,
    finalAmount: Number(data.payable_amount),
    displayPayableAmount: data?.display_payable_amount,
    amount: Number(data.amount),
    breakup: [],
    payBtnLabel: {
      zeroAmt: data.cta_text?.zero_amount_cta ?? "Confirm",
      default: data.cta_text?.default_cta ?? "Proceed to pay",
      lastPayment: data.cta_text?.lpm_cta ?? "Pay now",
    },
    showStrikeThrough: data.show_strikethrough_price,
    gstAmount: data.total_gst_amount ?? 0,
    strikeThroughAmt: data.strikethrough_price,
    extraDetails: []
  };
  data.payment_summary?.forEach((el) => {
    summary.breakup.push(serializeLineItem(el));
  });
  data.extra_details?.forEach((el) => {
    summary.extraDetails.push(serializeExtraDetails(el));
  })

  return summary;
}

const getSummary = async (
  body: DictType
): Promise<{
  response?: SummaryData;
  error?: any;
}> => {
  const url = `${apiConfig("omsNew")}/latest/order-summary/`;
  const { response, error }: any = await postMethod({
    endPoint: url,
    body,
    headers: getDefaultHeaders({
      effectivePlatform: true,
    }),
  });
  if (response) {
    if (response.data) {
      return { response: serializeSummary(response.data) };
    } else return { error: {} };
  }
  if (error) return { error };
};

export default getSummary;
